import '@app/App.css';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@comps/ui/tooltip';
import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function ManualButton() {
  const { t } = useTranslation();

  return (
    <TooltipProvider>
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
        <Link to="/manual" target="_blank" rel="noopener noreferrer" >
          <QuestionMarkCircledIcon className='cursor-pointer h-6 w-6' style={{ borderColor: "white", color: "white" }}/>
        </Link>
        </TooltipTrigger>
        <TooltipContent>
          {t('header.manual.tooltip.button')}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default ManualButton;
